// src/components/PlanCtaLink.tsx
//
// 2026-07-15・CEO指示：プラン比較CTA・/select-planページ閲覧の計測が存在しない問題への対応（LOOP_LOGIC.md S25）。
// /select-plan へ遷移するCTAを、出どころ（source）付きの1コンポーネントに統一する。
//
// - クリック時に plan_cta_click イベントを送信（source props でバナー/サイドバー/等の出どころを記録）
// - 遷移先URLに ?src=... を付与し、/select-plan 側の閲覧イベント（select_plan_view）で
//   流入元をクエリパラメータから読み取れるようにする
//
// "use client" のため、サーバーコンポーネントからも children（文字列・JSX）だけを渡す形で
// 安全に利用できる（関数propsをサーバーコンポーネントの子要素として渡すとクラッシュするため、
// クリックハンドラはこのコンポーネント内に閉じ込めている。2026-07-15の /admin/users 障害と同種の
// 問題を避けるための設計）。

"use client";

import Link from "next/link";
import type { ReactNode } from "react";
import { useEventLogger } from "@/lib/useEventLogger";

export default function PlanCtaLink({
  source,
  className,
  children,
}: {
  source: string;
  className?: string;
  children: ReactNode;
}) {
  const { log } = useEventLogger();

  return (
    <Link
      href={`/select-plan?src=${encodeURIComponent(source)}`}
      className={className}
      onClick={() => log("plan_cta_click", { source })}
    >
      {children}
    </Link>
  );
}
